import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminLogin() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    api
      .get("/auth/me")
      .then(() => navigate("/admin", { replace: true }))
      .catch(() => setChecking(false));
  }, [navigate]);

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <main className="min-h-screen bg-steel flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md text-center">
        <img
          src="/images/logo-header-light.png"
          alt="T.A.L.K. — The Analog Life Kintsugi"
          className="h-11 w-auto mx-auto"
        />
        <h1 className="mt-12 font-display text-offwhite font-medium text-4xl leading-[1.1]" data-testid="admin-login-heading">
          The Bookings Inbox
        </h1>
        <p className="mt-5 text-[#B9B4AA] text-sm leading-relaxed">
          Private to Rajdeep. Everything that arrives through the site — sessions,
          enquiries and reset requests — in one quiet place.
        </p>

        {state?.denied && (
          <p className="mt-8 border border-[#8C3A28] bg-[#8C3A28]/15 px-5 py-4 text-sm text-[#E9B7A8]" data-testid="admin-login-denied">
            That Google account isn't allowed in here. Sign in with the studio's own address.
          </p>
        )}

        {checking ? (
          <Loader2 size={20} className="mx-auto mt-12 text-goldsoft animate-spin" data-testid="admin-login-checking" />
        ) : (
          <button
            onClick={signIn}
            data-testid="admin-google-signin-button"
            className="mt-12 w-full bg-goldsoft text-steel text-xs uppercase tracking-[0.24em] font-semibold px-8 py-4 hover:bg-offwhite transition-colors duration-300"
          >
            Continue with Google
          </button>
        )}
      </div>
    </main>
  );
}
